/* eslint-disable prettier/prettier */
// /* eslint-disable prettier/prettier */
// import React, { useContext, useEffect, useState } from 'react';
// import Fade from 'react-reveal/Fade';
// // import Tilt from 'react-tilt';
// import { Container, Row, Col } from 'react-bootstrap';
// import PortfolioContext from '../../context/context';
// import Title from '../Title/Title';
// // import ProjectImg from '../Image/ProjectImg';

// const Projects = () => {
//   const { projects } = useContext(PortfolioContext);
//   const { title, info, info2, url, id } = projects;

//   const [isDesktop, setIsDesktop] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     if (window.innerWidth > 769) {
//       setIsDesktop(true);
//       setIsMobile(false);
//     } else {
//       setIsMobile(true);
//       setIsDesktop(false);
//     }
//   }, []);

//   return (
//     <section id="projects">
//       <Container>
//         <div className="project-wrapper">
//           <Title title="Projects" />
//           <Row key={id}>
//             <Col lg={4} sm={12}>
//               <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={500} distance="30px">
//                 <div className="project-wrapper__text">
//                   <h3 className="project-wrapper__text-title">{title || 'Paw-five'}</h3>
//                   <div>
//                     <p>
//                       {info ||
//                         'Paw five is an online platform who works toward saving pets from All over iraq by providing a away in which people who want to adope pets can easily find a pet to adopt from all cities of iraq and kurdistan and people who want to adopt a can add pets to the website to be adopted. tha main goal of this webiste is to rescue homless animals  using ReactJs, Firebase'}
//                     </p>
//                     <p className="mb-4">{info2 || ''}</p>
//                   </div>
//                   <a
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="cta-btn cta-btn--hero"
//                     href={url || 'https://paw-five.ml/'}
//                   >
//                     See Live
//                   </a>

//                   <a
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="cta-btn text-color-main"
//                     href={url || 'https://github.com/Faeza97/capstone-iraq-rct-paw-five'}
//                   >
//                     Source Code
//                   </a>
//                 </div>
//               </Fade>
//             </Col>
//             <Col lg={4} sm={12}>
//               <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={500} distance="30px">
//                 <div className="project-wrapper__text">
//                   <h3 className="project-wrapper__text-title">{title || 'Hotel Booking'}</h3>
//                   <div>
//                     <p>
//                       {info ||
//                         'Hotel Reservations System are a popular method for booking hotel rooms. Travellers can book rooms on a computer by using online security to protect their privacy and financial information and by using several online travel agents to compare prices and facilities at different hotels. its my Final Research Project for stage 4 using PHP, MySQL, JS, jQuery, and Bootstrap'}
//                     </p>
//                     <p className="mb-4">{info2 || ''}</p>
//                   </div>
//                   {/* <a
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="cta-btn cta-btn--hero"
//                     href={url || '#'}
//                   >
//                     See Live
//                   </a> */}

//                   <a
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="cta-btn cta-btn--hero"
//                     href={url || 'https://github.com/Faeza97/Hotel-Reservation-System/tree/master'}
//                   >
//                     Source Code
//                   </a>
//                 </div>
//               </Fade>
//             </Col>
//             <Col lg={4} sm={12}>
//               <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={500} distance="30px">
//                 <div className="project-wrapper__text">
//                   <h3 className="project-wrapper__text-title">{title || 'Weather Forecast App'}</h3>
//                   <div>
//                     <p>
//                       {info ||
//                         'The weather app also provides atmospheric pressure, weather conditions, visibility distance, relative humidity, precipitation in different unites, dew point, wind speed and direction, in addition to ten days in future and hourly weather forecast. It features the basics, including extended forecasts and hourly forecasts developed using ReactJs, axios, API, and React Bootstrap'}
//                     </p>
//                     <p className="mb-4">{info2 || ''}</p>
//                   </div>
//                   <a
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="cta-btn cta-btn--hero"
//                     href={url || 'https://weatherapp-cpp-team.netlify.app/'}
//                   >
//                     See Live
//                   </a>

//                   <a
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="cta-btn text-color-main"
//                     href={url || 'https://github.com/murtaja1/weather_app_js'}
//                   >
//                     Source Code
//                   </a>
//                 </div>
//               </Fade>
//             </Col>

//             {/* <Col lg={8} sm={12}>
//               <Fade
//                 right={isDesktop}
//                 bottom={isMobile}
//                 duration={1000}
//                 delay={1000}
//                 distance="30px"
//               >
//                 <div className="project-wrapper__image">
//                   <a
//                     href={url || '#!'}
//                     target="_blank"
//                     aria-label="Project Link"
//                     rel="noopener noreferrer"
//                   >
//                     <Tilt
//                       options={{
//                         reverse: false,
//                         max: 8,
//                         perspective: 1000,
//                         scale: 1,
//                         speed: 300,
//                         transition: true,
//                         axis: null,
//                         reset: true,
//                         easing: 'cubic-bezier(.03,.98,.52,.99)',
//                       }}
//                     >
//                       <div data-tilt className="thumbnail rounded">
//                         <ProjectImg alt={title} filename={img} />
//                       </div>
//                     </Tilt>
//                   </a>
//                 </div>
//               </Fade>
//             </Col> */}
//           </Row>
//         </div>
//       </Container>
//     </section>
//   );
// };

// export default Projects;
import React, { useContext, useEffect, useState } from 'react';
import Fade from 'react-reveal/Fade';
import Tilt from 'react-tilt';
import { Container, Row, Col } from 'react-bootstrap';
import PortfolioContext from '../../context/context';
import Title from '../Title/Title';
import ProjectImg from '../Image/ProjectImg';

const Projects = () => {
  const { projects } = useContext(PortfolioContext);

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
    <section id="projects">
      <Container>
        <div className="project-wrapper">
          <Title title="Projects" />
          {projects.map((project) => {
            const { title, info, info2, url, repo, img, id } = project;

            return (
              <Row key={id}>
                <Col lg={4} sm={12}>
                  <Fade
                    left={isDesktop}
                    bottom={isMobile}
                    duration={1000}
                    delay={500}
                    distance="30px"
                  >
                    <div className="project-wrapper__text">
                      <h3 className="project-wrapper__text-title">{title || 'Project Title'}</h3>
                      <div>
                        <p>
                          {info ||
                            'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Excepturi neque, ipsa animi maiores repellendu distinctioaperiam earum dolor voluptatum consequatur blanditiis inventore debitis fuga numquam voluptate architecto itaque molestiae.'}
                        </p>
                        <p className="mb-4">{info2 || ''}</p>
                      </div>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cta-btn cta-btn--hero"
                        href={url || '#!'}
                      >
                        See Live
                      </a>

                      {repo && (
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          className="cta-btn text-color-main"
                          href={repo}
                        >
                          Source Code
                        </a>
                      )}
                    </div>
                  </Fade>
                </Col>
                <Col lg={8} sm={12}>
                  <Fade
                    right={isDesktop}
                    bottom={isMobile}
                    duration={1000}
                    delay={1000}
                    distance="30px"
                  >
                    <div className="project-wrapper__image">
                      <a
                        href={url || '#!'}
                        target="_blank"
                        aria-label="Project Link"
                        rel="noopener noreferrer"
                      >
                        <Tilt
                          options={{
                            reverse: false,
                            max: 8,
                            perspective: 1000,
                            scale: 1,
                            speed: 300,
                            transition: true,
                            axis: null,
                            reset: true,
                            easing: 'cubic-bezier(.03,.98,.52,.99)',
                          }}
                        >
                          <div data-tilt className="thumbnail rounded">
                            <ProjectImg alt={title} filename={img} />
                          </div>
                        </Tilt>
                      </a>
                    </div>
                  </Fade>
                </Col>
              </Row>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default Projects;
